export enum TopAssetTypes {
  demo = 'demo',
  tour = 'tour',
  playbook = 'playbook',
}
export type TopAssetType = keyof typeof TopAssetTypes;

export enum TopAssetsSorts {
  last_updated = 'last_updated',
  top_results = 'top_results',
}
export type TopAssetsSort = keyof typeof TopAssetsSorts;

type TopAssetAnalyticsData = {
  visits: number;
  sessions: number;
};

type TopAssetActivity = {
  action: string;
  creatorEmail?: string;
  creatorName?: string;
  updateTime: string;
};

export type TopAssetStatus = 'active' | 'shared' | 'deleted' | 'inactive';

export type TopAsset = {
  assetId: string;
  assetType: TopAssetType;
  assetRevisionId?: number;
  workspaceId: string;
  updateTime: string;
  createTime: string;
  name: string;
  isDeleted: boolean;
  isFavorite?: boolean;
  image?: string;
  recordingType?: string;
  analyticsData?: TopAssetAnalyticsData;
  lastActivity?: TopAssetActivity;
  status: TopAssetStatus;
};
